var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC2DoorClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 58V14H23v44h-5v4h40v-4h-5zm-4 0H27V18h22v40zm-9-20a2 2 0 012-2h3a2 2 0 010 4h-3a2 2 0 01-2-2z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C2_Door_close.28a8514a.svg";
export { SvgC2DoorClose as ReactComponent };